import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { editEntityField, setEditedEntity, saveBrand } from '../../../actions';
import { withRouter } from 'react-router-dom';

class BrandEditor extends Component {
    containsForbiddenChars = (input) => {
        // eslint-disable-next-line no-useless-escape
        return /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|[\u0590-\u05fe]/.test(input);
    }
    
    handleSubmit = (event) => {
        if (!this.containsForbiddenChars(this.props.entity.key)) {
            this.props.saveBrand(this.props.entity, brand => this.props.history.push(`brands/${brand.key}`));
        }

        event.preventDefault();
    }

    render() {
        const { entity, editEntityField } = this.props;

        const brand = entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <Input
                        fluid
                        required
                        placeholder={`${i18next.t('brands.brandKey')}...`}
                        value={brand.key || ''}
                        onChange={({ target }) => {
                            editEntityField('key', target.value);
                            if (this.containsForbiddenChars(target.value)) {
                                target.setCustomValidity(i18next.t('brands.brandKeyError'));
                            } else {
                                target.setCustomValidity('');
                            }
                        }}
                    />
                </Form.Field>

                <Form.Field>
                    <label style={{ padding: '0 5px' }}>{i18next.t('brands.platform')}</label>
                    <Dropdown
                        fluid
                        selection
                        options={[{ text: i18next.t('kiosk'), value: 'kiosk' }, { text: i18next.t('website.title'), value: 'website' }]}
                        onChange={(e, { value }) => editEntityField('platform', value)}
                        value={brand.platform}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

BrandEditor.propTypes = {
    saveBrand: PropTypes.func,
    editEntityField: PropTypes.func,
    setEditedEntity: PropTypes.func,
    entity: PropTypes.object,
    
    history: PropTypes.object,
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, {
    saveBrand,
    editEntityField,
    setEditedEntity,
})(withRouter(BrandEditor));
